import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageType, Route } from '@bca-shared/models/_enums';
import { IMessage } from '@bca-shared/models/message';

@Component({
  selector: 'bca-notification',
  templateUrl: 'notification.component.html',
  styleUrls: ['notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationComponent {
  @Input()
  message: IMessage;
  @Input()
  currentRoute: Route;
  @Output()
  close = new EventEmitter<IMessage>();

  Route = Route;
  MessageType = MessageType;
}
